module.exports = global["moment"] = require("-!./moment.js");


//////////////////
// WEBPACK FOOTER
// ./~/moment/moment.js-exposed
// module id = 19
// module chunks = 1